import logo from '../../assets/logo-text.svg'
import logoWhite from '../../assets/logo-text-white.svg'
import moment from 'moment'
import facebook from '../../assets/icons/facebook.svg'
import google from '../../assets/icons/google.svg'



const translations = {
    REGISTER_STEPS: {
        METHOD_SELECTION:1,
        USER_TYPE_SELECTION:2,
        PERSONAL_INFORMATION:3,
        CREATE_YOUR_PROFILE:4,
        OVERVIEW:10
    },
    join:'Unirse',
    register_method_section:{
        title:'Elige tu forma de registro',
        forgotten_password:'¿Olvidaste tu contraseña?',
        login_button:'Iniciar sesión',
        noaccount:'¿Ya tienes cuenta?',
        joinus:'Inicia sesión',
        facebook_logo:facebook,
        google_logo:google,
        banner:null,
    },
    user_type_section:{
        title:'¿Qué usuario eres?',
        user_types:[
        ],
    },
    personal_information_section:{
        title:'Información personal',
        form:{
            birth_date:{placeholder:'Fecha de nacimiento', label:'', helperText:'Campo requerido'},
            gender_id:{placeholder:'Género', label:'', helperText:'Campo requerido'},
        },
        next_button:'Siguiente'
    },
    profile_section:{
        title:'Crea tu perfil',
        form:{
            first_name:{placeholder:'Nombre(s)', label:'Nombre(s)', helperText:'Campo requerido'},
            last_name:{placeholder:'Apellido(s)', label:'Apellido(s)', helperText:'Campo requerido'},
            username:{placeholder:'Usuario', label:'Usuario', helperText:'Campo requerido'},
            email:{placeholder:'test@inpager.co', label:'Correo electrónico', helperText:'Campo requerido'},
            password:{placeholder:'Contraseña', label:'Contraseña', helperText:'Campo requerido'},
            password_confirmation:{placeholder:'Confirmar contraseña', label:'Confirmar contraseña', helperText:'Campo requerido'},
        },
        next_button:'Unirse'
    },
    overview_section:{
        title:'¡Felicidades!',
        message:'Tu cuenta ha sido creada exitósamente',
        submessage:'En breve te enviaremos un correo de confirmación a', 
        next_button:'Finalizar'
    },
    form:{
        email:{placeholder:'Email', label:'Email', helperText:'Campo requerido'},
        password:{placeholder:'Contraseña', label:'Contraseña', helperText:'Campo requerido'},
    },
    topbar:{
        logo:logo,
        register:'Únete ahora',
        login:'Iniciar sesión'
    },
    bottombar:{
        logo:logoWhite,
        media:[
            {id:1, name:'facebook', icon:null},
            {id:2, name:'twitter', icon:null},
            {id:3, name:'instagram', icon:null},
        ],
        links:{
            first_column:[
                {id:1, label:'Agencias', link:'/'},
                {id:2, label:'Influencers', link:'/'},
                {id:3, label:'Prensa', link:'/'},
                {id:4, label:'Marcas', link:'/'},
            ],
            second_column:[
                {id:1, label:'Contacto', link:'/'},
                {id:2, label:'Acerca de', link:'/'},
                {id:3, label:'Servicios', link:'/'},
            ],
            third_column:[
                {id:1, label:'Términos de uso', link:'/'},
                {id:2, label:'Aviso de privacidad', link:'/'},
                {id:3, label:'Ayuda', link:'/'},
            ],
        },
        copyright: `Copyright @ ${moment().year()} InPager`
    },
    
    
}

export default translations